import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import { Box, CircularProgress, Typography } from "@mui/material";
import { PrimaryTypography } from "../../Theme";

import { useNavigate, useParams } from "react-router-dom";
import CompanyDetails from "./SalesOverviewforms/CompanyDetails";
import ReviewAccount from "./SalesOverviewforms/ReviewAccount";
import AdministratorDetails from "./SalesOverviewforms/AdministratorDetails";
import ProjectInformation from "./SalesOverviewforms/ProjectInformation";
import axiosInstance from "../../AxiosInstance";

import moment from "moment";
import { showToast } from "../../CommonComponents/Toaster";
import { useDialog } from "../../contexts/DialogContext";
import {
  validateAdministratorDetails,
  validateCompanyDetails,
  validateProjectDetails,
} from "../../utils/validate";

const EditAccount = () => {
  const [addblocks, setaddblocks] = useState({
    Company_Details: true,
    Project_Information: false,
    Administrator_Details: false,
    Review_Account: false,
  });
  const [openAddCompanyDialog, setOpenAddCompanyDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [trialDisable, setTrialDisable] = useState(false);
  const [PDF, setPDF] = useState({
    fileName: "",
    fileSize: "",
    fileType: "",
    path: "",
  });
  const [nonEditableFile, setNonEditableFile] = useState(false);
  const { showDialog } = useDialog();

  const [projectTypes, setProjectTypes] = useState([]);
  const { id } = useParams();
  const [administratorDetails, setAdministratorDetails] = useState({
    full_name: "",
    email_address: "",
  });
  const [administratorErrText, setAdministratorErrText] = useState({
    full_name: "",
    email_address: "",
  });
  const [companyDetails, setCompanyDetails] = useState({
    company_category: "",
    company_name: "",
    company_country: "",
    company_email_address: "",
    company_contact_number: "",
    company_address: "",
    company_country_code: "",
    company_type: "",
    billing_entity: "",
    billing_full_name: "",
    billing_email_address: "",
    billing_cycle: "",
    billing_cycle_id: "",
    billing_contact_number: "",
    billing_contract_terms: "",
    billing_country_code: "",
    billing_commence_date: null,
    billing_end_date: null,
    contract: "",
  });
  const [projectDetails, setProjectDetails] = useState({
    project_title: "",
    type: "",
    completion_year: "",
    tenure: "",
    units: "",
    address: "",
    country: "",
    city: "",
    postal_code: "",
    full_name: "",
    email_address: "",
    position: "",
    contact_number: "",
    country_code: "",
  });
  const [projectDetailsErrText, setProjectDetailsErrText] = useState({
    project_title: "",
    type: "",
    completion_year: "",
    tenure: "",
    units: "",
    address: "",
    country: "",
    city: "",
    postal_code: "",
    full_name: "",
    email_address: "",
    position: "",
    contact_number: "",
  });
  const [companies, setCompanies] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const topRef = useRef(null);
  const [billingCycle, selectBillingCycle] = useState([]);
  const [companyDetailsErrText, setCompanyDetailsErrText] = useState({
    company_category: "",
    company_name: "",
    company_country: "",
    company_email_address: "",
    company_contact_number: "",
    company_address: "",
    company_country_code: "",

    billing_entity: "",
    billing_full_name: "",
    billing_email_address: "",
    billing_cycle: "",

    billing_contact_number: "",
    billing_contract_terms: "",
    billing_country_code: "",
    billing_commence_date: "",
    billing_end_date: "",
    contract: "",
  });

  const navigate = useNavigate();

  const blocks = [
    { status: addblocks.Company_Details, tle: "Company Details" },
    { status: addblocks.Project_Information, tle: "Project Information" },
    { status: addblocks.Administrator_Details, tle: "Administrator Details" },
    { status: addblocks.Review_Account, tle: "Review Account" },
  ];

  const Continue = (nxtval) => {
    if (nxtval === "Company Details") {
      setaddblocks({
        Company_Details: true,
        Project_Information: false,
        Administrator_Details: false,
        Review_Account: false,
      });
    }

    if (nxtval === "Project Information") {
      if (
        validateCompanyDetails(
          companyDetails,
          PDF,
          companyDetailsErrText,
          setCompanyDetailsErrText,
          trialDisable
        )
      ) {
        setaddblocks({
          Company_Details: false,
          Project_Information: true,
          Administrator_Details: false,
          Review_Account: false,
        });
      }
    }
    if (nxtval === "Administrator Details") {
      if (
        validateCompanyDetails(
          companyDetails,
          PDF,
          companyDetailsErrText,
          setCompanyDetailsErrText,
          trialDisable
        ) &&
        validateProjectDetails(
          projectDetails,
          projectDetailsErrText,
          setProjectDetailsErrText
        )
      ) {
        setaddblocks({
          Company_Details: false,
          Project_Information: false,
          Administrator_Details: true,
          Review_Account: false,
        });
      }
    }
    if (nxtval === "Review Account") {
      if (
        validateCompanyDetails(
          companyDetails,
          PDF,
          companyDetailsErrText,
          setCompanyDetailsErrText,
          trialDisable
        ) &&
        validateProjectDetails(
          projectDetails,
          projectDetailsErrText,
          setProjectDetailsErrText
        ) &&
        validateAdministratorDetails(
          administratorDetails,
          administratorErrText,
          setAdministratorErrText
        )
      ) {
        setaddblocks({
          Company_Details: false,
          Project_Information: false,
          Administrator_Details: false,
          Review_Account: true,
        });
      }
    }
  };
  const getCompanyData = () => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}company`)
      .then((res) => {
        const companyData = res?.data?.data?.companies?.map((value) => ({
          label: value?.name,
          id: value?.id,
        }));
        console.log("companyData", companyData);
        setCompanies([...companyData, { label: "Add New Company", id: null }]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getbillingCycleData = async () => {
    await axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}getDropDownDatas?type=property_billing_cycle`
      )
      .then((res) => {
        selectBillingCycle(res?.data?.data?.drop_down);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getProjectType = () => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}getDropDownDatas?type=property_type`
      )
      .then((res) => {
        console.log("projectType", res?.data?.data?.drop_down);
        setProjectTypes(res?.data?.data?.drop_down || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAccountDetails = () => {
    setPageLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}property/${id}`)
      .then((res) => {
        setCompanyDetails((prev) => ({
          ...prev,
          company_name: res.data?.data?.property?.company?.name,
          company_country: res?.data?.data?.property?.company?.country,
          company_email_address: res?.data?.data?.property?.company?.email,
          company_contact_number: `${res?.data?.data?.property?.company?.country_code}${res?.data?.data?.property?.company?.phone}`,
          company_country_code:
            res?.data?.data?.property?.company?.country_code,
          company_address: res?.data?.data?.property?.company?.address,
          billing_entity: res?.data?.data?.property?.billing_detail?.entity,
          billing_full_name: res?.data?.data?.property?.billing_detail?.name,
          billing_email_address:
            res?.data?.data?.property?.billing_detail?.email,
          billing_cycle:
            res?.data?.data?.property?.billing_detail?.billing_cycle,
          billing_contact_number: `${res?.data?.data?.property?.billing_detail?.country_code} ${res?.data?.data?.property?.billing_detail?.phone}`,
          billing_contract_terms: `${res?.data?.data?.property?.billing_detail?.contract_terms_year} years ${res?.data?.data?.property?.billing_detail?.contract_terms_month} months`,
          billing_country_code:
            res?.data?.data?.property?.billing_detail?.country_code,
          billing_commence_date: moment(
            res?.data?.data?.property?.billing_detail?.commence_date,
            "DD-MM-YYYY"
          ),
          billing_end_date: moment(
            res?.data?.data?.property?.billing_detail?.end_date,
            "DD-MM-YYYY"
          ),
          contract: "",
        }));
        setPDF({
          fileName:
            res.data?.data?.property?.billing_detail?.contract_doc?.name,
          fileSize:
            res.data?.data?.property?.billing_detail?.contract_doc?.file_size,
          fileType:
            res.data?.data?.property?.billing_detail?.contract_doc?.file_type,
          path: res.data?.data?.property?.billing_detail?.contract_doc?.path,
        });
        setNonEditableFile(
          res.data?.data?.property?.billing_detail?.contract_doc
        );
        setProjectDetails((prev) => ({
          ...prev,
          project_title: res?.data?.data?.property?.title,
          type: res?.data?.data?.property?.type,
          completion_year: res?.data?.data?.property?.completion_year,
          tenure: res?.data?.data?.property?.tenure_year,
          units: res?.data?.data?.property?.total_units,
          address: res?.data?.data?.property?.address,
          country: res?.data?.data?.property?.country,
          city: res?.data?.data?.property?.city,
          postal_code: res?.data?.data?.property?.zipcode,
          full_name: res?.data?.data?.property?.contact_detail?.name,
          email_address: res?.data?.data?.property?.contact_detail?.email,
          position: res?.data?.data?.property?.contact_detail?.position,
          contact_number: `${res?.data?.data?.property?.contact_detail?.country_code}${res?.data?.data?.property?.contact_detail?.phone}`,
          country_code: res?.data?.data?.property?.contact_detail?.country_code,
        }));
        setAdministratorDetails({
          full_name: res?.data?.data?.property?.name,
          email_address: res?.data?.data?.property?.email,
        });
        setPageLoading(false);
      })
      .catch((err) => {
        setPageLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getCompanyData();
    getbillingCycleData();

    getProjectType();
    getAccountDetails();
  }, []);
  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [addblocks]);
  const getCompanyDataById = (id) => {
    setCategoryLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}company/${id}`)
      .then((res) => {
        if (res?.status === 200) {
          setCompanyDetails((prev) => ({
            ...prev,
            company_name: res.data?.data?.company?.name,
            company_country: res?.data?.data?.company?.country,
            company_email_address: res?.data?.data?.company?.email,
            company_contact_number: `${res?.data?.data?.company?.country_code}${res?.data?.data?.company?.phone}`,
            company_country_code: res?.data?.data?.company?.country_code,
            company_address: res?.data?.data?.company?.address,
          }));
          setCompanyDetailsErrText((prev) => ({
            ...prev,
            company_name: "",
            company_country: "",
            company_email_address: "",
            company_contact_number: "",
            company_country_code: "",
            company_address: "",
          }));
          setCategoryLoading(false);
          setDisable(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setCategoryLoading(false);
      });
  };
  useEffect(() => {
    if (companyDetails?.company_category?.label === "Add New Company") {
      setOpenAddCompanyDialog(true);
      setCompanyDetails((prev) => ({
        ...prev,
        company_category: "",
        company_name: "",
        company_country: "",
        company_email_address: "",
        company_contact_number: "",
        company_country_code: "",
        company_address: "",
      }));
      setDisable(false);
    } else if (companyDetails?.company_category?.id) {
      getCompanyDataById(companyDetails?.company_category?.id);
    }
  }, [companyDetails?.company_category]);
  useEffect(() => {
    if (companyDetails?.billing_cycle?.id === 4) {
      setCompanyDetails((prev) => ({
        ...prev,
        billing_contract_terms: "0 Years 1 months",
      }));
      setCompanyDetailsErrText((prev) => ({
        ...prev,
        billing_contract_terms: "",
      }));
      setTrialDisable(true);
      if (companyDetails?.billing_commence_date) {
        const commenceDate = moment(companyDetails.billing_commence_date);
        const endDate = commenceDate.clone().add(30, "days");

        // Update state or use the new date
        setCompanyDetails((prev) => ({
          ...prev,
          billing_end_date: endDate, // Save formatted date
        }));
        setCompanyDetailsErrText((prev) => ({
          ...prev,
          billing_end_date: "",
        }));
      }
    } else {
      setCompanyDetails((prev) => ({
        ...prev,
        billing_contract_terms: "",
      }));
      setTrialDisable(false);
    }
  }, [companyDetails?.billing_cycle, companyDetails?.billing_commence_date]);
  const handleSubmit = async () => {
    setLoading(true);
    const [years, months] = companyDetails?.billing_contract_terms
      .split(" ")
      .filter((item, index) => index === 0 || index === 2); // Get first and third items

    const contract_terms = {
      years: Number(years),
      months: Number(months),
    };

    const formData = new FormData();

    formData.append("title", projectDetails?.project_title);
    formData.append("type", projectDetails?.type?.id);
    formData.append("completion_year", Number(projectDetails?.completion_year));
    formData.append("tenure_year", projectDetails?.tenure);
    formData.append("total_units", projectDetails?.units);

    // Administrator details
    formData.append("name", administratorDetails?.full_name);
    formData.append("email", administratorDetails?.email_address);
    formData.append(
      "phone",
      `${projectDetails?.contact_number.slice(
        projectDetails?.country_code?.length
      )}`
    );
    formData.append("country_code", projectDetails?.country_code);
    formData.append("address", projectDetails?.address);
    formData.append("country", projectDetails?.country);
    formData.append("city", projectDetails?.city);
    formData.append("zipcode", projectDetails?.postal_code);

    // Billing details
    formData.append("billing_details[entity]", companyDetails?.billing_entity);
    formData.append("billing_details[name]", companyDetails?.billing_full_name);
    formData.append(
      "billing_details[email]",
      companyDetails?.billing_email_address
    );
    formData.append(
      "billing_details[country_code]",
      `${companyDetails?.billing_country_code}`
    );
    formData.append(
      "billing_details[phone]",
      companyDetails?.billing_contact_number.slice(
        companyDetails?.billing_country_code.length
      )
    );
    formData.append(
      "billing_details[billing_cycle]",
      companyDetails?.billing_cycle?.id
    );
    formData.append(
      "billing_details[contract_terms_year]",
      contract_terms?.years
    );

    if (PDF?.path === "" && companyDetails?.contract) {
      formData.append(
        "billing_details[contract_doc]",
        companyDetails?.contract
      );
    }
    formData.append(
      "billing_details[contract_terms_month]",
      contract_terms?.months
    );
    formData.append(
      "billing_details[commence_date]",
      companyDetails?.billing_commence_date
        ? companyDetails?.billing_commence_date
        : ""
    );
    formData.append(
      "billing_details[end_date]",
      companyDetails?.billing_end_date ? companyDetails?.billing_end_date : ""
    );
    // formData.append("billing_details[contract_doc]", companyDetails?.contract);

    // Contact details
    formData.append("contact_details[name]", projectDetails?.full_name);
    formData.append("contact_details[position]", projectDetails?.position);
    formData.append("contact_details[email]", projectDetails?.email_address);
    formData.append(
      "contact_details[country_code]",
      `${projectDetails?.country_code}`
    );
    formData.append(
      "contact_details[phone]",
      projectDetails?.contact_number.slice(projectDetails?.country_code.length)
    );

    if (companyDetails?.company_category?.id) {
      formData.append("company[id]", companyDetails?.company_category?.id);
    } else {
      // Company details
      formData.append("company[name]", companyDetails?.company_name);
      formData.append("company[email]", companyDetails?.company_email_address);
      formData.append(
        "company[country_code]",
        `${companyDetails?.company_country_code}`
      );
      formData.append(
        "company[phone]",
        companyDetails?.company_contact_number.slice(
          companyDetails?.company_country_code.length
        )
      );
      formData.append("company[address]", companyDetails?.company_address);
      formData.append("company[country]", companyDetails?.company_country);
    }
    // Log FormData
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}property/${id}`,
        formData,
        {
          "Content-Type": "multipart/form-data", // Ensure correct content type for FormData
        }
      );
      // navigate("/company");
      if (response?.status === 200) {
        navigate("/sales-overview");
        showDialog({
          title: "Account Updated",
          content:
            "This account has been successfully Updated.  Development team will now prepare onboarding",
        });
      }
      setLoading(false);
      console.log(response.data);
    } catch (error) {
      console.error(error);
      if (error.response) {
        if (error.response.status === 400) {
          const { validation_error } = error.response.data?.data;

          if (validation_error) {
            const updatedCompanyErrText = { ...companyDetailsErrText };
            const updatedAdministratorErrText = { ...administratorErrText };
            const updatedProjectErrText = { ...projectDetailsErrText };
            Object.keys(validation_error).forEach((key) => {
              if (key === "company.name") {
                updatedCompanyErrText.company_name =
                  "Company name is already existed";
                setaddblocks({
                  Company_Details: true,
                  Project_Information: false,
                  Administrator_Details: false,
                  Review_Account: false,
                });
                setCompanyDetailsErrText(updatedCompanyErrText);
                showToast("Company name is already existed", "error");
              }
              if (key === "title") {
                updatedProjectErrText.project_title =
                  "Project Title is already existed";
                setaddblocks({
                  Company_Details: false,
                  Project_Information: true,
                  Administrator_Details: false,
                  Review_Account: false,
                });
                setProjectDetailsErrText(updatedProjectErrText);
                showToast("Project Title is already existed", "error");
              }
              if (key === "name") {
                updatedAdministratorErrText.full_name =
                  "Full Name is already existed";
                setaddblocks({
                  Company_Details: false,
                  Project_Information: false,
                  Administrator_Details: true,
                  Review_Account: false,
                });
                setAdministratorErrText(updatedAdministratorErrText);
                showToast("Full Name is already existed", "error");
              }
              if (key === "email") {
                updatedAdministratorErrText.email_address =
                  "Email is already existed";
                setaddblocks({
                  Company_Details: false,
                  Project_Information: false,
                  Administrator_Details: true,
                  Review_Account: false,
                });
                setAdministratorErrText(updatedAdministratorErrText);
                showToast("Email is already existed", "error");
              }
            });
          }
        } else {
          showToast("Something went wrong! Please try again.", "error");
        }
      }

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const RenderComponent = () => {
    switch (true) {
      case addblocks.Company_Details:
        return (
          <CompanyDetails
            companyDetails={companyDetails}
            setCompanyDetails={setCompanyDetails}
            setCompanyDetailsErrText={setCompanyDetailsErrText}
            companyDetailsErrText={companyDetailsErrText}
            companies={companies}
            disable={disable}
            categoryLoading={categoryLoading}
            setaddblocks={setaddblocks}
            billingCycle={billingCycle}
            setPDF={setPDF}
            PDF={PDF}
            open={openAddCompanyDialog}
            setOpen={setOpenAddCompanyDialog}
            getCompanyData={getCompanyData}
            trialDisable={trialDisable}
          />
        );
      case addblocks.Project_Information:
        return (
          <ProjectInformation
            projectDetails={projectDetails}
            setProjectDetails={setProjectDetails}
            setaddblocks={setaddblocks}
            setProjectDetailsErrText={setProjectDetailsErrText}
            projectDetailsErrText={projectDetailsErrText}
            projectTypes={projectTypes}
          />
        );
      case addblocks.Administrator_Details:
        return (
          <AdministratorDetails
            administratorDetails={administratorDetails}
            setaddblocks={setaddblocks}
            setAdministratorDetails={setAdministratorDetails}
            administratorErrText={administratorErrText}
            setAdministratorErrText={setAdministratorErrText}
          />
        );
      case addblocks.Review_Account:
        return (
          <ReviewAccount
            companyDetails={companyDetails}
            projectDetails={projectDetails}
            administratorDetails={administratorDetails}
            setaddblocks={setaddblocks}
            handleSubmit={handleSubmit}
            loading={loading}
          />
        );

      default:
        return null;
    }
  };

  return pageLoading ? (
    <Box
      sx={{ width: "100%", height: "90vh" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress />
    </Box>
  ) : (
    <div ref={topRef}>
      <Box>
        <BackArrow
          onClick={() => navigate("/sales-overview")}
          style={{ marginBottom: "20px", cursor: "pointer" }}
        />
        <PrimaryTypography>Edit Account</PrimaryTypography>
      </Box>
      <Box sx={{ marginTop: "30px" }} display="flex" gap="1.5%" mb={5}>
        {blocks.map((itm) => (
          <Box
            key={itm.tle}
            onClick={() => Continue(itm.tle)}
            sx={{
              borderTop: itm.status ? "3px solid #0E4965" : "3px solid #D2D6DB",
              width: "25%",
              color: itm.status ? "#0E4965" : "#D2D6DB",
              cursor: "pointer",
            }}
          >
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "12px",
                color: itm.status ? "#0E4965" : "#9DA4AE",
                padding: "10px 0 0 0",
              }}
            >
              {itm.tle}
            </Typography>
          </Box>
        ))}
      </Box>
      {RenderComponent()}
    </div>
  );
};

export default EditAccount;
